import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { TagsContainer as Container, UserTag as Tag } from 'components/ui';

const defaultProps = {
  onTagRemove: () => {}
};
const propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      cls: PropTypes.string,
      icon: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    })
  ).isRequired,
  onTagRemove: PropTypes.func
};

const SelectedTags = ({ data, onTagRemove }) => (
  <Container title={<FormattedMessage id="page.Section_SharedTo.title" />}>
    {data.map(tag => (
      <Tag
        key={tag.key}
        classes={tag.cls}
        closable
        iconType={tag.icon}
        name={tag.name}
        onClose={() => onTagRemove(tag.id, tag.type)}
      />
    ))}
  </Container>
);

SelectedTags.defaultProps = defaultProps;
SelectedTags.propTypes = propTypes;
export default SelectedTags;



// WEBPACK FOOTER //
// ./src/views/Section_SharedTo/components/SelectedTags.jsx